import React, { useEffect, useState, useContext, useRef } from 'react';

const Video = (props) => {
	useEffect(() => {
		if (!props.mediaStream) return;

		props.videoRef.current.srcObject = props.mediaStream;
		try {
			props.videoRef.current.play();
		} catch (error) {
			console.error('error playing', error);
		}
	}, [props.mediaStream?.id]);
	return (
		<video
			className={'w-full rounded-lg'}
			style={props.mirror ? { transform: 'scale(-1, 1)' } : {}}
			ref={props.videoRef}
			muted
		></video>
	);
};

const MediaStreamHasChanged = (prevProps, nextProps) => {
	return prevProps.mediaStream?.id == nextProps.mediaStream?.id && prevProps.mirror === nextProps.mirror;
};

const MemoizedVideo = React.memo(Video, MediaStreamHasChanged);

const MediaElement = (props) => {
	return (
		<div className="relative media-element min-h-0">
			<MemoizedVideo
				name={props.name}
				mirror={props.mirror}
				mediaStream={props.mediaStream}
				videoRef={props.videoRef}
			/>
			{/* <div className="absolute top-0 right-0 mr-3 -mt-2 text-2xl onhover text-ivory">...</div> */}
			<div className={'hidden absolute top-0 right-0 mt-6'}>hallo</div>

			{props.name == '' ? (
				''
			) : (
				<span
					className={
						'truncate max-w-4/5 capitalize absolute rounded px-2 py-1/2 bottom-2 left-2 bg-black bg-opacity-50 text-ivory text-sm font-medium'
					}
				>
					{props.name}
				</span>
			)}
		</div>
	);
};

export default MediaElement;
